export const handleReferer = () => {
  const referer: string | null = sessionStorage.getItem('referrer')
  if (!referer) {
    sessionStorage.setItem('referer', JSON.stringify(document.referrer))
  }
}

